<template>
  <div :key="action + bookingId">
    <BookingGroupForm
      :action="action"
      :booking-id="bookingId"
    ></BookingGroupForm>
  </div>
</template>
<script>
import BookingGroupForm from './components/BookingGroupForm.vue'

export default {
  components: { BookingGroupForm },
  data() {
    return {
      defaultBookingRooms: null
    }
  },
  computed: {
    bookingId() {
      return this.$route.query?.id
    },
    action() {
      const actions = ['create', 'edit', 'view']
      const queryAction = this.$route.query?.action
      if (!actions.includes(queryAction)) {
        return 'create'
      } else {
        return queryAction
      }
    }
  },
  created() {
    const selectRooms = sessionStorage.getItem('defaultRooms')

    sessionStorage.removeItem('defaultRooms')

    this.defaultBookingRooms = selectRooms ? JSON.parse(selectRooms) : null
  }
}
</script>
